import { InvoicePlusOutlineIcon } from './InvoicePlusOutlineIcon';

/**
 * author: Jeff Anders
 * id 889F97FC-E068-4E7A-BB6E-0F3428A13A21
 * name invoice-plus-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-plus-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceNewOutlineIcon = InvoicePlusOutlineIcon;
export default InvoiceNewOutlineIcon